import React, { useState } from 'react';
import GlobalDialog from '../../../../../components/mui/Dialogue/GlobalDialog';
import { CancelButton, DeleteButton } from '../../../../../components/mui/Buttons/Buttons';
import { Box, Stack, TextField, Typography } from '@mui/material';
import { Form, FormikProvider, useFormik } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { useSnackbar } from 'notistack';
import * as Yup from 'yup';
import { deleteCourseEnrollment } from '../../../../../redux/features/CRDslice';

const validationSchema = Yup.object().shape({
  reason: Yup.string().required('A reason is required to delete this course').trim(),
});

const DeleteCourseEnrollment = ({ row, dispatchParams, apiCall }) => {
  const [open, setOpen] = useState(false);
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const { loading } = useSelector((state) => state.crd);

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      course_enrollment_id: row?.course_enrollment_id,
      reason: '',
    },
    validationSchema,
    onSubmit: (values) => {
      dispatch(deleteCourseEnrollment(values)).then((res) => {
        if (res.payload.status === 'success') {
          enqueueSnackbar(res.payload.message, { variant: 'success' });
          setOpen(false);
          formik.resetForm();
          if (apiCall) {
            dispatch(apiCall(dispatchParams));
          }
        } else {
          enqueueSnackbar(res.payload.message, { variant: 'error' });
        }
      });
    },
  });

  return (
    <GlobalDialog
      title={'Delete Course'}
      open={open}
      setOpen={setOpen}
      fullWidth
      maxWidth={'sm'}
      closeButton={true}
      popupButton={
        <DeleteButton size="small" action={() => setOpen(true)}>
          Delete Course
        </DeleteButton>
      }
      content={
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Box>
              <Typography sx={{ pb: 2 }}>
                Are you sure you want to delete this course? This permanently removes the enrollment along with its
                sessions, payments, and invoices — this cannot be undone.
              </Typography>
              <TextField
                fullWidth
                label="Reason"
                name="reason"
                multiline
                rows={3}
                value={formik.values.reason}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.reason && Boolean(formik.errors.reason)}
                helperText={formik.touched.reason && formik.errors.reason}
              />
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', pt: 2 }}>
                <Stack direction={'row'} spacing={1}>
                  <CancelButton size="small" action={() => setOpen(false)}>
                    Cancel
                  </CancelButton>
                  <DeleteButton disabled={loading} size="small" action={formik.handleSubmit}>
                    {loading ? 'Please wait...' : 'Delete'}
                  </DeleteButton>
                </Stack>
              </Box>
            </Box>
          </Form>
        </FormikProvider>
      }
    />
  );
};

export default DeleteCourseEnrollment;
